<template>
  <div class="project-filters">
    <el-radio-group v-model="groupBy" size="mini" class="group-by">
      <el-radio-button label="Created At" v-if="showCreatedBy"></el-radio-button>
      <el-radio-button label="Client Name" v-if="showClientName"></el-radio-button>
      <el-radio-button label="A-Z" v-if="showAZ"></el-radio-button>
    </el-radio-group>
    <el-checkbox-group v-model="typeFilter" size="mini" class="status-filter">
      <el-checkbox-button label="prospect" key="prospect" @change="setLastTypeStatus('prospect')">Prospect</el-checkbox-button>
      <el-checkbox-button label="approved" key="approved" @change="setLastTypeStatus('approved')">Approved</el-checkbox-button>
    </el-checkbox-group>
    <el-checkbox-group v-model="statusFilter" size="mini" class="status-filter">
      <el-checkbox-button label="active" key="active" @change="setLastFilterStatus('active')">Open</el-checkbox-button>
      <el-checkbox-button label="inactive" key="inactive" @change="setLastFilterStatus('inactive')">Closed</el-checkbox-button>
    </el-checkbox-group>
  </div>
</template>

<script>
  export default {
    name: 'project-filters',
    props: {
      showCreatedBy: { default: true },
      showClientName: { default: true },
      showAZ: { default: true }
    },
    data () {
      return {
        groupBy: 'Created At',
        typeFilter: [],
        statusFilter: [],
        lastFilterType: null,
        lastFilterStatus: null
      }
    },
    mounted () {
      this.groupBy = this.$store.state.filters.projectsGroupBy
      this.typeFilter = this.$store.state.filters.projectsTypeFilter
      this.statusFilter = this.$store.state.filters.projectsStatusFilter
    },
    methods: {
      setLastTypeStatus (status) {
        this.lastFilterType = status
      },
      setLastFilterStatus (status) {
        this.lastFilterStatus = status
      }
    },
    watch: {
      groupBy () {
        this.$store.dispatch('setProjectsGroupBy', this.groupBy)
      },
      typeFilter () {
        // Toggle the Status Filter buttons (prevent multiple from being selected)

        // If the change in status filter caused more than 1 element to be selected
        // we need to remove everything other than the last selected item
        if (this.typeFilter.length > 1) {
          this.typeFilter = [this.lastFilterType]
        }
        this.$store.dispatch('setProjectsTypeFilter', this.typeFilter)
      },
      statusFilter () {
        // Toggle the Status Filter buttons (prevent multiple from being selected)

        // If the change in status filter caused more than 1 element to be selected
        // we need to remove everything other than the last selected item
        if (this.statusFilter.length > 1) {
          this.statusFilter = [this.lastFilterStatus]
        }
        this.$store.dispatch('setProjectsStatusFilter', this.statusFilter)
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .project-filters {
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
  }
  .status-filter,
  .group-by {
    margin-left: 20px;
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
  }
</style>
